import { render, staticRenderFns } from "./zscy.vue?vue&type=template&id=08ebc5db&scoped=true"
import script from "./zscy.vue?vue&type=script&lang=js"
export * from "./zscy.vue?vue&type=script&lang=js"
import style0 from "./zscy.vue?vue&type=style&index=0&id=08ebc5db&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08ebc5db",
  null
  
)

export default component.exports